import {
  type ThemeContent,
  type StyleSheet,
} from '../../../providers/ThemeProvider';

export default (theme: ThemeContent): StyleSheet => ({
  dialogContainer: {
    position: 'relative',
    zIndex: 10,
  },
  blurContainer: {
    position: 'fixed',
    inset: 0,
    backgroundColor: theme.colors.gray,
    opacity: '50%',
  },
  dialogOuterContainer: {
    position: 'fixed',
    inset: 0,
    overflowY: 'auto',
    zIndex: 10,
  },
  dialogInnerContainer: {
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'end',
  },
  panel: {
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: 'white',
    alignSelf: 'center',
    transition: 'all',
    boxShadow:
      '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
    borderRadius: '0.5rem',
    padding: '2%',
    width: '50vmin',
  },
  panelDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  btn: {
    display: 'flex',
    width: '100%',
    height: '10%',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  childrenContainer: {
    marginTop: '5%',
    marginBottom: '5%',
  },
  xmark: {
    position: 'absolute',
    right: 10,
    top: 10,
    color: '#808080',
    cursor: 'pointer',
  },
});
